export default __webpack_public_path__ + "static/media/show 1.7f475792.svg";